import { atom } from 'recoil'

export const localeState = atom<string>({
  key: 'locale-state',
  default: 'en-us'
})
